export const CHATS_REQUEST = 'CHATS_REQUEST';
export const CHATS_SUCCESS = 'CHATS_SUCCESS';
export const RULES_REQUEST = 'RULES_REQUEST';
export const RULES_SUCCESS = 'RULES_SUCCESS';
export const CLEAR_INFO = 'CLEAR_INFO';
